


<template>
<div class="header-bar">
  <div class="nav">
    <div class="logo">
      <svg width="172" height="24" viewBox="0 0 172 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 17.0396H4.21887C4.21887 18.8478 5.5397 19.8763 7.87955 19.8763C10.2161 19.8763 11.4396 19.097 11.4396 17.819C11.4396 16.7903 10.6835 16.0457 8.99267 15.727L5.71819 15.1243C2.69683 14.5563 0.681509 12.8554 0.681509 9.73467C0.684755 6.72119 3.31019 4.41768 7.77245 4.41768C12.2347 4.41768 15.2528 6.86634 15.2528 10.4131H11.3585C11.2871 8.747 9.85592 7.6773 7.7335 7.6773C5.86422 7.6773 4.67645 8.42199 4.67645 9.76938C4.67645 10.8675 5.4683 11.4702 7.0163 11.7542L10.1837 12.3569C13.4192 12.9627 15.5773 14.3448 15.5773 17.819C15.5773 21.3658 12.1958 23.3506 7.87955 23.3506C2.87857 23.3506 0.107094 20.9051 0 17.0396Z" fill="#333333"/>
        <path d="M132.732 17.0396H136.951C136.951 18.8478 138.272 19.8763 140.612 19.8763C142.948 19.8763 144.172 19.097 144.172 17.819C144.172 16.7903 143.416 16.0457 141.724 15.727L138.45 15.1243C135.429 14.5563 133.413 12.8554 133.413 9.73467C133.413 6.72119 136.039 4.41768 140.501 4.41768C144.964 4.41768 147.985 6.86634 147.985 10.4131H144.09C144.019 8.747 142.588 7.6773 140.465 7.6773C138.596 7.6773 137.409 8.42199 137.409 9.76938C137.409 10.8675 138.2 11.4702 139.748 11.7542L142.916 12.3569C146.152 12.9596 148.312 14.3417 148.312 17.8159C148.31 21.3658 144.928 23.3506 140.612 23.3506C135.611 23.3506 132.839 20.9051 132.732 17.0396Z" fill="#333333"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M45.1908 12.3064C40.1022 12.3064 37.97 14.4047 37.97 17.6423C37.97 20.8704 40.0633 23.3506 44.24 23.3506C46.768 23.3506 48.6698 22.4291 49.77 20.8704H50.2372L50.6267 23.035H53.872V10.8328C53.872 7.21659 51.0875 4.41768 46.106 4.41768C41.3452 4.41768 38.6191 7.09037 38.6191 10.7286H42.5135C42.5135 9.16353 43.4968 7.74987 45.9989 7.74987C48.634 7.74987 49.9776 9.02784 49.9776 10.7286V12.3064H45.1908ZM49.9776 14.9885V15.7868C49.9776 18.3018 48.1343 20.1352 45.1551 20.1352C42.8835 20.1352 41.7023 19.0023 41.7023 17.5129C41.7023 15.8815 42.7278 14.9885 45.4343 14.9885H49.9776Z" fill="#333333"/>
        <path d="M57.7663 4.73639L61.0116 4.73323L61.479 7.11246H61.9495C62.9393 5.55366 64.7858 4.41768 67.5022 4.41768C71.6853 4.41768 74.3173 6.97047 74.3173 11.0821V23.035H70.0983V12.2244C70.0983 9.74414 68.8652 8.06857 66.243 8.06857C63.5365 8.07173 61.9852 9.83565 61.9852 12.9375V23.035H57.7663V4.73639Z" fill="#333333"/>
        <path d="M130.136 23.0319L126.89 23.035L126.424 20.6558H125.952C124.964 22.2146 123.116 23.3506 120.4 23.3506C116.217 23.3506 113.585 20.7978 113.585 16.6862V4.73326H117.804V15.5439C117.804 18.0241 119.037 19.6997 121.659 19.6997C124.366 19.6997 125.917 17.9358 125.917 14.8339V4.73326H130.136V23.0319Z" fill="#333333"/>
        <path d="M80.6744 17.7181V8.20425H75.9395V4.73322H80.8204V0H84.7959V4.73322H91.5169V8.20425H84.7959V19.564H91.5169V23.035H86.1686C82.1932 23.035 80.6744 20.8735 80.6744 17.7181Z" fill="#333333"/>
        <path d="M154.018 17.7181V8.20425H149.282V4.73322H154.163V0H158.139V4.73322H164.86V8.20425H158.139V19.564H164.86V23.035H159.512C155.536 23.035 154.018 20.8735 154.018 17.7181Z" fill="#333333"/>
        <path d="M94.7624 19.564H98.4166V8.20426H94.7624V4.73323H101.577L101.902 7.57317H102.551C103.349 5.68619 105.092 4.41768 107.451 4.41768H110.015V8.20426H107.341C104.183 8.20426 102.554 10.29 102.554 14.064V19.564H110.015V23.035H94.7527L94.7624 19.564Z" fill="#333333"/>
        <path d="M26.988 19.9111C23.7979 19.9111 22.2304 17.5003 22.2304 13.8841C22.2304 10.3374 23.746 7.88872 26.936 7.88872C29.0487 7.88872 30.4572 8.99945 30.8304 10.7286H35.0492C34.4002 6.94207 31.9662 4.41768 26.936 4.41768C21.1692 4.41768 18.1738 8.24528 18.1738 13.8841C18.1738 19.5577 21.2925 23.3506 27.0627 23.3506C31.989 23.3506 34.6079 20.7062 35.0492 17.0396H30.8304C30.5059 18.7877 29.1332 19.9111 26.988 19.9111Z" fill="#333333"/>
        <path d="M172 4.73326H168.43V8.20429H172V4.73326Z" fill="#15BBF0"/>
        <path d="M172 19.564H168.43V23.035H172V19.564Z" fill="#15BBF0"/>
      </svg>
    </div>
    <nav class="links" v-if="$store.state.authorized">
      <nav-link :active="selection=='home'" disabled><router-link to="/">Dashboard</router-link></nav-link>
      <nav-link :active="selection=='products'">
        <router-link to="/products" >Products</router-link>
        <tutorial-dialog :task="0" :step="1" position="bottom" style="margin-top: 10px;">First click on Products edit your product settings.</tutorial-dialog>
      </nav-link>
      <nav-link :active="selection=='landing-page'">
        <router-link to="/landing-page?tab=editor">Landing Page</router-link>
        <tutorial-dialog :task="1" :step="1" position="bottom" style="margin-top: 10px;">Use the Landing Page editor create your custom landing page.</tutorial-dialog>
      </nav-link>
      <nav-link :active="selection=='upgrade'" disabled><router-link to="/upgrade">Upgrade</router-link></nav-link>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              class="account-icon"
          >


                <v-icon>
                  mdi-account-circle
                </v-icon>

            <div class="plan-pill">
              <svg width="24" height="11" viewBox="0 0 24 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 1C0 0.447715 0.447715 0 1 0H23C23.5523 0 24 0.447715 24 1V10C24 10.5523 23.5523 11 23 11H1C0.447716 11 0 10.5523 0 10V1Z" fill="#65CD5D"/>
                <path d="M4.90723 6.62256V9H3.79541V2.60156H6.24316C6.95801 2.60156 7.5249 2.7876 7.94385 3.15967C8.36572 3.53174 8.57666 4.02393 8.57666 4.63623C8.57666 5.26318 8.37012 5.75098 7.95703 6.09961C7.54688 6.44824 6.97119 6.62256 6.22998 6.62256H4.90723ZM4.90723 5.73047H6.24316C6.63867 5.73047 6.94043 5.63818 7.14844 5.45361C7.35645 5.26611 7.46045 4.99658 7.46045 4.64502C7.46045 4.29932 7.35498 4.02393 7.14404 3.81885C6.93311 3.61084 6.64307 3.50391 6.27393 3.49805H4.90723V5.73047ZM10.585 9H9.51709V2.25H10.585V9ZM14.6323 8.53418C14.3188 8.90332 13.8735 9.08789 13.2964 9.08789C12.7808 9.08789 12.3896 8.93701 12.123 8.63525C11.8594 8.3335 11.7275 7.89697 11.7275 7.32568V4.24512H12.7954V7.3125C12.7954 7.91602 13.0459 8.21777 13.5469 8.21777C14.0654 8.21777 14.4155 8.03174 14.5972 7.65967V4.24512H15.665V9H14.6587L14.6323 8.53418ZM19.418 7.70801C19.418 7.51758 19.3389 7.37256 19.1807 7.27295C19.0254 7.17334 18.7661 7.08545 18.4028 7.00928C18.0396 6.93311 17.7363 6.83643 17.4932 6.71924C16.96 6.46143 16.6934 6.08789 16.6934 5.59863C16.6934 5.18848 16.8662 4.8457 17.2119 4.57031C17.5576 4.29492 17.9971 4.15723 18.5303 4.15723C19.0986 4.15723 19.5571 4.29785 19.9058 4.5791C20.2573 4.86035 20.4331 5.2251 20.4331 5.67334H19.3652C19.3652 5.46826 19.2891 5.29834 19.1367 5.16357C18.9844 5.02588 18.7822 4.95703 18.5303 4.95703C18.2959 4.95703 18.104 5.01123 17.9546 5.11963C17.8081 5.22803 17.7349 5.37305 17.7349 5.55469C17.7349 5.71875 17.8037 5.84619 17.9414 5.93701C18.0791 6.02783 18.3574 6.12012 18.7764 6.21387C19.1953 6.30469 19.5234 6.41455 19.7607 6.54346C20.001 6.66943 20.1782 6.82178 20.2925 7.00049C20.4097 7.1792 20.4683 7.396 20.4683 7.65088C20.4683 8.07861 20.291 8.42578 19.9365 8.69238C19.582 8.95605 19.1177 9.08789 18.5435 9.08789C18.1538 9.08789 17.8066 9.01758 17.502 8.87695C17.1973 8.73633 16.96 8.54297 16.79 8.29688C16.6201 8.05078 16.5352 7.78564 16.5352 7.50146H17.5723C17.5869 7.75342 17.6821 7.94824 17.8579 8.08594C18.0337 8.2207 18.2666 8.28809 18.5566 8.28809C18.8379 8.28809 19.0518 8.23535 19.1982 8.12988C19.3447 8.02148 19.418 7.88086 19.418 7.70801Z" fill="white"/>
              </svg>
            </div>


          </v-btn>
        </template>
        <v-list dense>

          <v-list-item-group>

          <v-list-item>
            <v-list-item-icon class="mr-3 flex align-center">
              <svg width="24" height="11" viewBox="0 0 24 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 1C0 0.447715 0.447715 0 1 0H23C23.5523 0 24 0.447715 24 1V10C24 10.5523 23.5523 11 23 11H1C0.447716 11 0 10.5523 0 10V1Z" fill="#65CD5D"/>
                <path d="M4.90723 6.62256V9H3.79541V2.60156H6.24316C6.95801 2.60156 7.5249 2.7876 7.94385 3.15967C8.36572 3.53174 8.57666 4.02393 8.57666 4.63623C8.57666 5.26318 8.37012 5.75098 7.95703 6.09961C7.54688 6.44824 6.97119 6.62256 6.22998 6.62256H4.90723ZM4.90723 5.73047H6.24316C6.63867 5.73047 6.94043 5.63818 7.14844 5.45361C7.35645 5.26611 7.46045 4.99658 7.46045 4.64502C7.46045 4.29932 7.35498 4.02393 7.14404 3.81885C6.93311 3.61084 6.64307 3.50391 6.27393 3.49805H4.90723V5.73047ZM10.585 9H9.51709V2.25H10.585V9ZM14.6323 8.53418C14.3188 8.90332 13.8735 9.08789 13.2964 9.08789C12.7808 9.08789 12.3896 8.93701 12.123 8.63525C11.8594 8.3335 11.7275 7.89697 11.7275 7.32568V4.24512H12.7954V7.3125C12.7954 7.91602 13.0459 8.21777 13.5469 8.21777C14.0654 8.21777 14.4155 8.03174 14.5972 7.65967V4.24512H15.665V9H14.6587L14.6323 8.53418ZM19.418 7.70801C19.418 7.51758 19.3389 7.37256 19.1807 7.27295C19.0254 7.17334 18.7661 7.08545 18.4028 7.00928C18.0396 6.93311 17.7363 6.83643 17.4932 6.71924C16.96 6.46143 16.6934 6.08789 16.6934 5.59863C16.6934 5.18848 16.8662 4.8457 17.2119 4.57031C17.5576 4.29492 17.9971 4.15723 18.5303 4.15723C19.0986 4.15723 19.5571 4.29785 19.9058 4.5791C20.2573 4.86035 20.4331 5.2251 20.4331 5.67334H19.3652C19.3652 5.46826 19.2891 5.29834 19.1367 5.16357C18.9844 5.02588 18.7822 4.95703 18.5303 4.95703C18.2959 4.95703 18.104 5.01123 17.9546 5.11963C17.8081 5.22803 17.7349 5.37305 17.7349 5.55469C17.7349 5.71875 17.8037 5.84619 17.9414 5.93701C18.0791 6.02783 18.3574 6.12012 18.7764 6.21387C19.1953 6.30469 19.5234 6.41455 19.7607 6.54346C20.001 6.66943 20.1782 6.82178 20.2925 7.00049C20.4097 7.1792 20.4683 7.396 20.4683 7.65088C20.4683 8.07861 20.291 8.42578 19.9365 8.69238C19.582 8.95605 19.1177 9.08789 18.5435 9.08789C18.1538 9.08789 17.8066 9.01758 17.502 8.87695C17.1973 8.73633 16.96 8.54297 16.79 8.29688C16.6201 8.05078 16.5352 7.78564 16.5352 7.50146H17.5723C17.5869 7.75342 17.6821 7.94824 17.8579 8.08594C18.0337 8.2207 18.2666 8.28809 18.5566 8.28809C18.8379 8.28809 19.0518 8.23535 19.1982 8.12988C19.3447 8.02148 19.418 7.88086 19.418 7.70801Z" fill="white"/>
              </svg>
            </v-list-item-icon>
            <v-list-item-title>ePac Connect Plus</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-icon class="mr-3"><v-icon>mdi-logout</v-icon></v-list-item-icon>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
          </v-list-item-group>
        </v-list>

      </v-menu>

    </nav>
  </div>
</div>
</template>

<script>
import NavLink from "@/components/NavLink";
import TutorialDialog from "@/components/TutorialDialog";
export default {
    name: "header-bar",
  components: {TutorialDialog, NavLink},
  props: {
      selection: {
        type:String,
        default: 'home'
      }
  },
    data: function(){
        return {}
        },
    methods: {
      completeStep: function(){

        this.$store.dispatch("completeStep",{ task: 0, step: 1 } )

      },

      logout: function(){
        this.$store.dispatch("logout");
      }
    },
    computed: {}
}
</script>

<style scoped>


.header-bar {
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12);
}

.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  padding: 4px 16px;
  padding-bottom: 0;
  background-color: white;
  position: relative;
}

.logo {
  margin: 0;
  margin-left: 8px;
  padding-bottom: 0px;
  max-width: 170px;
}

.links {
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
}

.nav-link {
  height: 100%;
}

.v-menu__content {
  min-width: 230px!important;
}

.account-icon {
  position: relative;
}


.plan-pill {
  position: absolute;
  top: -15px;
  right: -10px;
}

</style>
